import React from 'react';
import { Link } from 'react-router-dom';

export const termsLabel = (
    <span>
        I have read and agree with the{' '}
        <Link to='/terms' target='_blank' onClick={e => e.stopPropagation()}>
            Terms of Use
        </Link>{' '}
        and{' '}
        <Link to='/privacy' target='_blank' onClick={e => e.stopPropagation()}>
            Privacy Policy
        </Link>
    </span>
);

export const termsError =
    'Agreement to the Terms of Use and Privacy Policy is required.';
